<template>
  <card
    :id="`resource-component_${resourceType}-${name}_list`"
    :title="title ?? trans('models.' + resourceType + '.relations.' + name)"
    class="position-relative"
  >
    <slot name="top" />
    <resource-collection
      :collection-type="resource.data.collections[name].meta.config.component?.type ?? 'list'"
      :mode="'dashboard-component'"
      :models="resource.data.collections[name]"
      :name="name"
      :options="getOptions()"
      @detach="(detached) => $emit('detach', detached)"
      @updatePicked="updatePicked"
      @update:data="(data) => $emit('update:data', data)"
      @update:relation="(data) => $emit('update:relation', data)"
      @trigger:refresh="(data, page) => $emit('trigger:refresh', data, page)"
    ></resource-collection>
    <slot name="bottom" />
  </card>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Card,
    ResourceCollection,
  },
  props: {
    name: { type: String, default: '' },
    title: { type: String, default: null },
    resource: { type: Object, default: () => {} },
    options: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['updatePicked', 'update:picked', 'update:data', 'update:relation', 'trigger:refresh', 'detach'],
  setup(props, { emit }) {
    const { resourceType } = useResource(props, props.resource);

    const updatePicked = (pickedModel) => {
      emit('updatePicked', pickedModel); // deprecated
      emit('update:picked', pickedModel);
    };

    const getOptions = () => {
      let options = props.options ?? {};
      options.relation = props.resource.data.collections[props.name].meta.relationInfo;
      options.parentResource = props.resource;

      return options;
    };

    return {
      getOptions,
      resourceType,
      updatePicked,
    };
  },
};
</script>
